/**
 * @deprecated Consent is now set via inline Script in each app's layout.tsx
 * This component is kept for backwards compatibility but does nothing.
 * It will be removed in a future version.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export default function HubSpotConsentSetup() {
  return null;
}
